import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";

export default function BottomNav() {
  const { currentUser, getUnreadCount, getMySales, favorites } = useApp();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isActive = (path) => location.pathname === path;
  const unread = currentUser ? getUnreadCount() : 0;
  const newSales = currentUser ? (getMySales?.() || []).filter(s => s.status === "pending").length : 0;
  const favCount = favorites?.length || 0;

  if (!currentUser || !isMobile) return null;

  return (
    <nav style={s.nav}>
      <Link to="/" style={{...s.item,...(isActive("/")?s.itemActive:{})}}>
        <span style={s.icon}>🏠</span>
        <span style={s.label}>Inicio</span>
      </Link>

      <Link to="/advertise" style={{...s.item,...(isActive("/advertise")?s.itemActive:{})}}>
        <span style={s.icon}>📢</span>
        <span style={s.label}>Publicidad</span>
      </Link>

      {/* Boton publicar central */}
      <Link to="/new-product" style={s.publish}>
        <span style={{fontSize:26,lineHeight:1}}>+</span>
      </Link>

      <Link to="/favorites" style={{...s.item,...(isActive("/favorites")?s.itemActive:{})}}>
        <div style={{position:"relative"}}>
          <span style={s.icon}>❤️</span>
          {favCount>0 && <span style={s.dot}>{favCount}</span>}
        </div>
        <span style={s.label}>Favoritos</span>
      </Link>

      <Link to="/messages" style={{...s.item,...(isActive("/messages")?s.itemActive:{})}}>
        <div style={{position:"relative"}}>
          <span style={s.icon}>💬</span>
          {unread>0 && <span style={s.dot}>{unread}</span>}
        </div>
        <span style={s.label}>Mensajes</span>
      </Link>
    </nav>
  );
}

const s = {
  nav:{
    position:"fixed",
    bottom:0,
    left:0,
    right:0,
    background:"#fff",
    borderTop:"0.5px solid #e0e0e0",
    display:"flex",
    alignItems:"center",
    justifyContent:"space-around",
    padding:"8px 0 16px",
    zIndex:99,
    boxShadow:"0 -2px 10px rgba(0,0,0,0.06)",
    // Evitar scroll horizontal
    overflowX:"hidden",
    width:"100%",
    touchAction:"pan-y",
  },
  item:{
    display:"flex",
    flexDirection:"column",
    alignItems:"center",
    gap:3,
    textDecoration:"none",
    color:"#888",
    flex:1,
    position:"relative",
    minWidth:0,
    // Evitar que se achique demasiado
    maxWidth:"25%",
  },
  itemActive:{color:"#1D9E75"},
  icon:{fontSize:22},
  label:{fontSize:10,fontWeight:500,whiteSpace:"nowrap"},
  publish:{
    width:54,
    height:54,
    background:"#1D9E75",
    borderRadius:"50%",
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    color:"#fff",
    textDecoration:"none",
    marginTop: 1,
    boxShadow:"0 4px 14px rgba(29,158,117,0.45)",
    flexShrink:0,
    fontWeight:300,
  },
  dot:{
    position:"absolute",
    top:-4,
    right:-4,
    background:"#E24B4A",
    color:"#fff",
    borderRadius:"50%",
    width:16,
    height:16,
    fontSize:10,
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    fontWeight:600,
  },
};
